// src/App.js
import React from 'react';
import Navbar from './components/Navbar';
import Header from './components/Header';
import { ToastContainer } from 'react-toastify';
import AppRouter from './routes/AppRouter';

function App() {
  return (
    <>
      <Navbar />
      <Header />
      <AppRouter /> {/* 👈 Use the router component here */}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
